'use strict';
// @flow
interface User {
  name: string;
  email: string;
  password: string;
}

export default class LoginController {
  user: User = {
    name: '',
    email: '',
    password: ''
  };
  errors = { login: undefined };
  submitted = false;
  Auth;
  $location;


  /*@ngInject*/
  constructor(Auth, $location) {
    this.Auth = Auth;
    this.$location = $location;
  }

  login(form) {
    this.submitted = true;

    if (form.$valid) {
      this.Auth.login({
        email: this.user.email,
        password: this.user.password
      })
        .then(() => {
          // Logged in, redirect to home
          this.$location.path('/');
        })
        .catch(err => {
          this.errors.login = err.message;
        });
    }
  }

  validateField(form, name) {
    return {
      fieldRequired: form.$submitted && form[name].$error.required && form[name].$pristine,
      fieldInvalid: !form[name].$pristine && form[name].$invalid
    };
  }
}



// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.ts